// extracted by mini-css-extract-plugin
export default {"pageDescriptions":"GV1dm","descriptions":"pVnlE","productParameter":"nw60t"};